import { Component, OnInit, Renderer2 } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ActivatedRoute } from '@angular/router';
import { interval, Subscription, Observable } from 'rxjs';
import { AlertsService } from 'src/modules/base/services/alerts.service';

@Component({
  selector: 'kx-view-token',
  templateUrl: './view-token.component.html',
  styleUrls: ['./view-token.component.scss'],
  standalone: false
})
export class ViewTokenComponent implements OnInit {
  desk: any; screen_data: any;
  screen: any;
  haSubscription: Subscription;
  subscription: Subscription;
  myInterval: any; css: any;
  activeSlideIndex = 0;
  showIndicator: boolean = false
  // now: Date;
  token: any
  tokensList: boolean = false
  deskName: any; screenVisiblity: any = { 1: 100, 2: 98, 3: 96, 4: 94, 5: 92 }
  arrow: boolean = true
  selectServiceType: any = ['pharmacy']
  IssingleToken: boolean
  isMultiToken: boolean

  constructor(
    public baseService: BaseService,
    public alert: AlertsService,
    public renderer: Renderer2,
    public Aroute: ActivatedRoute
  ) {
    // setInterval(() => {
    //   this.now = new Date();
    // }, 1);
  }

  ngOnInit() {
    this.Aroute.params.subscribe((res: any) => {
      // this.getRefershTime(res.id);
      if (res && res.id)
        this.getScreenData(decodeURIComponent(res.id));
    })
  }

  getScreenData(id: any) {
    this.getScreenRefreshRate$(id).subscribe((data: any) => {
      this.screen_data = data.resource[0];
      this.hasBackgroundcolor();
      this.getData(id, data.resource[0].patient_per_queue);
      const source = interval(30 * 1000);
      const myInterval = interval(JSON.parse(data.resource[0].refresh_rate) * 1000);
      let x = 0;
      this.css = data.resource[0] && data.resource[0].css
        ? data.resource[0].css
        : '';

      if (this.css) {
        const style = this.renderer.createElement('style');
        style.textContent = this.css;
        this.renderer.appendChild(document.head, style);
      }
      this.myInterval = myInterval.subscribe(val => {
        x++;
        if (x == 1) {
          this.activeSlideIndex = 0;
        } else {
          if (this.screen?.length - 1 == this.activeSlideIndex) {
            this.activeSlideIndex = 0;
          } else {
            this.activeSlideIndex = this.activeSlideIndex + 1
          }
        }
      })
      this.haSubscription = source.subscribe(val => this.getData(id, data.resource[0].patient_per_queue));
    })
  }

  ngAfterViewInit() {
    setTimeout(function () {
      let hideSidebar: HTMLElement = document.getElementsByTagName("app-sidebar")[0] as HTMLElement;
      hideSidebar.style.display = "none";
    }, 5)
  }

  calculateStyles(_hasLength: any, deskSize?): any {
    if (Array.isArray(deskSize) && deskSize.length == 1 && deskSize.some(d => Array.isArray(d.queueDeskMapping) && d.queueDeskMapping.length === 1 && d.queueDeskMapping[0].is_user_desk === true)) {
      this.IssingleToken = true;
      this.isMultiToken = false;
    } else if (Array.isArray(deskSize) && deskSize.length > 1) {
      this.isMultiToken = true;
      this.IssingleToken = false;
    }
    if (deskSize !== undefined) {
      this.hasBackgroundcolor();
    }

    return { 'width': (this.screenVisiblity[_hasLength] / _hasLength) + "%" }
  }

  // getRefershTime(id: any) {
  //   this.getScreenRefreshRate$(id).subscribe((list: any) => {
  //     const source = interval(JSON.parse(list.resource[0].refresh_rate) * 1000);
  //     this.subscription = source.subscribe(val => this.scroll('carouselExampleIndicators'));
  //   })
  // }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
    this.haSubscription && this.haSubscription.unsubscribe();
    this.myInterval && this.myInterval.unsubscribe();
    let showbody: HTMLElement = document.getElementsByTagName("body")[0] as HTMLElement
    showbody.style.background = "";
    let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    hasColor.style.margin = null;
    hasColor.style.width = null;
    let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
    hasDisplay.style.removeProperty("display");
    let hideSidebar: HTMLElement = document.getElementsByTagName("app-sidebar")[0] as HTMLElement;
    hideSidebar.style.removeProperty("display");
    let container = document.getElementsByClassName("container-fluid")[0] as HTMLElement;
    container.style.backgroundColor = "rgb(250, 250, 250)";
  }

  hasBackgroundcolor() {
    let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    hasColor.style.margin = "0";
    hasColor.style.width = "100%";
    if (this.isMultiToken) {
      document.getElementsByTagName("body")[0].style.backgroundColor = this.screen_data && this.screen_data.bg_color_code ? this.screen_data.bg_color_code : "#000000";
      let container = document.getElementsByClassName("container-fluid")[0] as HTMLElement;
      container.style.backgroundColor = this.screen_data && this.screen_data.bg_color_code ? this.screen_data.bg_color_code : "#000000";
    }
    else {
      document.getElementsByTagName("body")[0].style.backgroundColor = this.screen_data && this.screen_data.bg_color_code ? this.screen_data.bg_color_code : "#d9d9d9";
      let container = document.getElementsByClassName("container-fluid")[0] as HTMLElement;
      container.style.backgroundColor = this.screen_data && this.screen_data.bg_color_code ? this.screen_data.bg_color_code : "#d9d9d9";
    }

    let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
    hasDisplay.style.display = "none"
  }

  gettokenslist(event: any) {
    this.token = event.queueDeskMapping
    this.deskName = this.token[0].desk_name
    if (this.token.length == 0) {
      this.alert.error("Over-booking not allowed!");
    }
    this.arrow = false
    if (this.tokensList == true) {
      this.tokensList = false
    }
    else {
      this.tokensList = true
    }
    // console.log("tokensList:",this.tokensList)
  }

  getData(key: any, token_limit: any) {
    this.getDataApi$(key, token_limit).subscribe((res: any) => {
      this.desk = res.resource;
      var deskperScreen;
      if (this.desk.length < 5) {
        deskperScreen = this.desk.length;
      } else {
        deskperScreen = 5;
      }
      var x = window.matchMedia("(max-width: 768px)")
      if (x.matches) {
        deskperScreen = this.desk.length;
      }
      this.screen = [];
      for (let i = 0; i < Math.ceil(this.desk.length / deskperScreen); i++) {
        if (i == 0) {
          this.screen.push(this.desk.slice(0, deskperScreen));
        }
        if (i > 0) {
          this.screen.push(this.desk.slice(i * deskperScreen, deskperScreen * (i + 1)))
        }
      }
      console.log("this.screen ", this.screen, "this.desk length ", this.desk);
    })
  }

  getDataApi$(key: any, token_limit: any): Observable<any> {
    return this.baseService.get("GET_BY_SCREEN", "screen_number:" + key + ",token_limit:" + token_limit, "queue_desk", "queue-management")
  }

  // onSlideChange(event: any) {
  //   if(event == undefined){
  //     this.activeSlideIndex = 0;
  //     this.activeClassIndex = 0;
  //   }else{
  //     this.activeSlideIndex = event;
  //     this.activeClassIndex = event;
  //   }
  // }

  // clickNextScreen() {
  //   let hasClickEvent: HTMLElement = document.getElementsByClassName("carousel-control-next")[0] as HTMLElement
  //   hasClickEvent.click()
  // }

  getScreenRefreshRate$(screen_number: any): Observable<any> {
    return this.baseService.get("GET_PAGE", "", "screen_master", "facility-management", "screen_number:" + screen_number)
  }

  // scroll(id) {
  //   let el = document.getElementById(id);
  //   el.scrollIntoView();
  // }

  getServiceInfo(event): boolean { // if only show token  event.serviceType_code is empty or null
    return this.selectServiceType.includes(event.serviceType_code);
  }

}